import { useContext } from 'react';

import { DineInContext } from '@/orders/providers/DineInContext';

export const useDineIn = () => useContext(DineInContext);
